export default __webpack_public_path__ + "static/media/icon-delete-white.86cc2c92.svg";